import * as React from 'react';

import { ConfirmModal } from '@coursera-web/cds-labs';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import SaveButton from 'bundles/account-settings/components/common/SaveButton';
import StatusMessage from 'bundles/account-settings/components/common/StatusMessage';
import CreditCardPreferenceInputRows from 'bundles/account-settings/components/sections/payment-method/CreditCardPreferenceInputRows';
import CreditCardSafetyNotice from 'bundles/account-settings/components/sections/payment-method/CreditCardSafetyNotice';
import CurrentWallet from 'bundles/account-settings/components/sections/payment-method/CurrentWallet';
import { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';
import { UserPreferenceKeys } from 'bundles/account-settings/constants/UserPreferences';
import SettingsStore from 'bundles/account-settings/stores/SettingsStore';
import { setUserPreference } from 'bundles/account-settings/utils/UserPreferenceUtils';
import Naptime from 'bundles/naptimejs';
import PaymentWalletsV1 from 'bundles/naptimejs/resources/paymentWallets.v1';
import SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import PaymentProcessorTypes from 'bundles/payments/common/PaymentProcessorTypes';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/ViewCurrentCard';

class ViewCurrentCard extends React.Component {
  static propTypes = {
    wallets: PropTypes.arrayOf(PropTypes.instanceOf(PaymentWalletsV1)).isRequired,
    showDeleteCreditCardModal: PropTypes.bool.isRequired,
    updateStatusDelete: PropTypes.shape({
      state: PropTypes.string.isRequired,
    }).isRequired,
    subscriptions: PropTypes.arrayOf(PropTypes.instanceOf(SubscriptionsV1)),
    activeWalletId: PropTypes.number,
  };

  state = {
    updateStatus: null,
  };

  handleCancelDeleteCard = () => {
    SettingsActionCreators.hideDeleteCreditCardModal();
  };

  handleConfirmDeleteCard = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'activeWalletId' does not exist on type '... Remove this comment to see the full error message
    const { activeWalletId } = this.props;
    SettingsActionCreators.hideDeleteCreditCardModal();
    SettingsActionCreators.deleteCreditCard(activeWalletId);
  };

  handleSaveChanges = (ev: $TSFixMe) => {
    ev.preventDefault();
    this.setState({ updateStatus: UpdateStates.UPDATING });
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'getFormData' does not exist on type 'typ... Remove this comment to see the full error message
    const prefFormData = CreditCardPreferenceInputRows.getFormData();
    setUserPreference(UserPreferenceKeys.PAYMENT, prefFormData)
      .then((res) => this.setState({ updateStatus: UpdateStates.SUCCEEDED }))
      .fail((err) => this.setState({ updateStatus: UpdateStates.FAILED }));
  };

  getActivePaymentType = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'activeWalletId' does not exist on type '... Remove this comment to see the full error message
    const { activeWalletId, wallets } = this.props;
    if (!activeWalletId) {
      return null;
    }

    const { paymentProcessorId } = _.find(wallets, { id: activeWalletId });
    switch (paymentProcessorId) {
      case PaymentProcessorTypes.paypal:
        return _t('PayPal account');
      case PaymentProcessorTypes.braintree:
        return _t('credit card');
      default:
        return _t('payment method');
    }
  };

  getCurrentWalletStatus = (walletId: $TSFixMe) => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'updateStatusDelete' does not exist on ty... Remove this comment to see the full error message
    const { updateStatusDelete, activeWalletId } = this.props;
    return walletId === activeWalletId ? updateStatusDelete : { state: UpdateStates.IDLE };
  };

  renderUpdateStoredWalletSection() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'showDeleteCreditCardModal' does not exis... Remove this comment to see the full error message
    const { showDeleteCreditCardModal, subscriptions, wallets, activeWalletId } = this.props;
    const hasActiveSubscriptions =
      subscriptions.filter(
        (subscription: SubscriptionsV1) =>
          ['ACTIVE', 'FREE_TRIAL', 'PAST_DUE'].includes(subscription.status || '') &&
          subscription.paymentInformation &&
          'org.coursera.payment.WalletSubscriptionPaymentInformation' in subscription.paymentInformation
      ).length > 0;

    return (
      <div className="stored-wallet">
        {wallets.map((wallet: $TSFixMe) => (
          <CurrentWallet
            key={wallet.id}
            updateStatusDelete={this.getCurrentWalletStatus(wallet.id)}
            wallet={wallet}
            activeWalletId={activeWalletId}
            showEditButton={hasActiveSubscriptions}
          />
        ))}

        <ConfirmModal
          open={showDeleteCreditCardModal}
          acceptLabel={_t('Delete')}
          onAccept={this.handleConfirmDeleteCard}
          onCancel={this.handleCancelDeleteCard}
        >
          <div>
            <FormattedMessage
              message={_t('Are you sure you want to delete your {paymentType}?')}
              paymentType={this.getActivePaymentType()}
            />
            {subscriptions?.length !== 0 && (
              <p>
                (
                {_t(
                  `This action will unsubscribe you from active subscriptions that use this card.
                  To avoid this, please edit your card information instead`
                )}
                )
              </p>
            )}
          </div>
        </ConfirmModal>
      </div>
    );
  }

  renderUpdateCreditCardPreferencesSection() {
    const { updateStatus } = this.state;
    return (
      <div className="preference-options">
        <form onSubmit={this.handleSaveChanges}>
          <CreditCardPreferenceInputRows />

          <CreditCardSafetyNotice />

          <div className="save-button-wrapper">
            {/* Submission is handled by the onSubmit handler for the form element */}
            <SaveButton
              onClick={(ev) => null}
              text={_t('Save Changes')}
              updating={updateStatus === UpdateStates.UPDATING}
            />

            {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
            {updateStatus && <StatusMessage status={this.state.updateStatus} />}
          </div>
        </form>
      </div>
    );
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'updateStatusDelete' does not exist on ty... Remove this comment to see the full error message
    const { updateStatusDelete } = this.props;
    const didDeleteSuccessfully = updateStatusDelete.state === UpdateStates.SUCCEEDED;
    return (
      <div className="rc-ViewCurrentCard">
        {didDeleteSuccessfully && (
          <p>
            <FormattedMessage message={_t('Your payment wallet was successfully deleted.')} />
          </p>
        )}
        <div>
          {this.renderUpdateStoredWalletSection()}
          <CreditCardSafetyNotice />
          {/*
              TODO: uncomment and adjust once these preferences map to individual CCs
              and are not set on the user level
              this.renderUpdateCreditCardPreferencesSection()
              */}
        </div>
      </div>
    );
  }
}

export default Naptime.createContainer(ViewCurrentCard, (props) => ({
  wallets: SettingsStore.getPaymentWallets(),
  // @ts-expect-error ts-migrate(2559) FIXME: Type 'never[]' has no properties in common with ty... Remove this comment to see the full error message
  subscriptions: SubscriptionsV1.me([]),
}));
